import * as React from 'react';

function SvgIconEdit(props) {
  return (
    <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.544 8.976a.64.64 0 01-.896 0 .643.643 0 010-.893L12.707.932a.64.64 0 01.894 0 .643.643 0 010 .894l-7.057 7.15zm6.232 5.274H2.188A1.45 1.45 0 01.75 12.808V2.192A1.45 1.45 0 012.188.75h7.095c.327 0 .61.302.61.647a.65.65 0 01-.646.647H2.584a.55.55 0 00-.542.545v9.858a.55.55 0 00.542.545h9.832a.55.55 0 00.542-.545V5.333a.65.65 0 01.646-.647.65.65 0 01.646.647v7.49c-.044.785-.697 1.427-1.474 1.427z" />
    </svg>
  );
}

export default SvgIconEdit;
